import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'

import SupplyBalance from 'components/SupplyBalance'
import MainForm from 'components/MainForm'

const useStyles = makeStyles({
  root: {
    marginTop: '3rem',
    marginBottom: '6rem',
  },
})

const Dashboard = () => {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <SupplyBalance />
      <MainForm />
    </Box>
  )
}

export default Dashboard
